export default "__VITE_ASSET__h6tke$4b__"